import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { ApiService } from "src/app/api.service";
import { TovpilCrudService } from "src/app/utils/tovpil-crud-service";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";
import { UrlBuilderService } from "src/app/utils/tovpil-url-builder.service";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";
import { ZoneCoordModel } from "../shared/models/zone-model";
import { CountryModel } from "../shared/models/country-model";
import { State } from "../shared/models/State";
import { NatioCoordModel } from "../shared/models/natio-model";
import { AddressBook } from "../shared/models/AddressBook";
@Component({
  selector: 'app-tovpil-catalogs-natio-detail',
  templateUrl: './tovpil-catalogs-natio-detail.component.html',
  styleUrls: ['./tovpil-catalogs-natio-detail.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class TovpilCatalogsNatioDetailComponent implements OnInit {
  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  titleName?: string;
  countries?: CountryModel[];
  filteredCountries: any[];
  states?: State[] = [];
  filteredStates: string[];
  cities?: any[];
  filteredCities: string[];
  neightborhoods?: string[];
  streets?: string[];
  zipCodes?: any[];
  countriesList: any[];
  minEndDate: Date;
  lstTeamZone: any[];
  zonalCoords: any;
  modalType: any;

  zoneId: string;
  zone : any;
  natioId: string;
  storeId: string = null;

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = false;

  /** Modal */
  addressDialog: boolean = false;

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private route: ActivatedRoute,
    private urlBuilderService: UrlBuilderService
  ) {
    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe((params) => { });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.currentUser = currentUser;
    }
  }

  /**
   * The function initializes form groups for configuration and data, and updates the configuration form
   * with query parameters from the route.
   */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
    console.debug(
      "TovpilCatalogsZonal() Preferencuas de usuario: " +
      JSON.stringify(this.globalUserPreferences, null, 2)
    );
  }

  /**
   * The function `createDataForm` in TypeScript initializes a form group with various form controls and
   * default values, as well as setting some controls as disabled.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      storeId: new FormControl({
        value: null,
        disabled: true,
      }),

      natId: new FormControl({
        value: null,
        disabled: true,
      }),

      coordName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(20),
        Validators.minLength(5),
      ]),
      shortName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(4),
      ]),

      begDate: new FormControl({ value: null, disabled: false }, [
        Validators.required,
      ]),

      country: new FormControl(null, [Validators.required]),
      coordInventory: new FormControl(false),
      superiorCoord: new FormControl(
        { value: null, disabled: true },
        [Validators.required]
      ),

      coordEmail: new FormControl(null, [
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), // Regex para correo
      ]),
      secreEmail: new FormControl(null, [
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), // Regex para correo
      ]),

      coordMainAddress: new FormControl({ value: null, disabled: false }, [
        Validators.maxLength(20),
        Validators.minLength(1),
      ]),
      coordWarehouseAddress: new FormControl({ value: null, disabled: false }, [
        Validators.required,
        Validators.maxLength(20),
        Validators.minLength(1),
      ]),

      //Modal
      addressDialogCountry: new FormControl(null, [Validators.required]),
      addressDialogState: new FormControl(null, [Validators.required]),
      addressDialogCity: new FormControl(null, [Validators.required]),
      addressDialogNeightborhood: new FormControl(null, [Validators.required]),
      addressDialogStreet: new FormControl(null, [Validators.required]),
      addressDialogZipCode: new FormControl(null, [Validators.required]),
      addressDialogId: new FormControl(null),

      // Main Direction Info
      mainCountry: new FormControl(null),
      mainState: new FormControl(null),
      mainCity: new FormControl(null),
      mainNeight: new FormControl(null),
      mainStreet: new FormControl(null),
      mainZipCode: new FormControl(null),
      mainAddress: new FormControl(null),
      mainAddressId: new FormControl(null),

      // Store Direction Info
      warehouseCountry: new FormControl(null),
      warehouseState: new FormControl(null),
      warehouseCity: new FormControl(null),
      warehouseNeight: new FormControl(null),
      warehouseStreet: new FormControl(null),
      warehouseZipCode: new FormControl(null),
      warehouseAddress: new FormControl(null),
      warehouseAddressId: new FormControl(null),

      // TABLE
      lstCountry: new FormControl([]),
      lstTeamZone: new FormControl([]),
      selectedTeamZone: new FormControl(null, Validators.required),
      lstAuxMembers: new FormControl([]),
      listZonesCoord: new FormControl([]),

      selectedCountry: new FormControl(null),
      selectedState: new FormControl(null),
      selectedCity: new FormControl(null),
    });
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.zoneId = params["zoneId"];
      this.natioId = params["natioId"];
    });
    this.getSecurity();
    this.getInitialInfo();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }
    await this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }


  /**
   * The function `getCountries` asynchronously retrieves a list of countries from an API service and
   * updates the global user data form with the retrieved countries.
   */
  async getCountries() {
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || "0000000002";
    this.countries = await this.apiService.getCoutriesFromStore({
      storeId: storeId,
    });
    this.globalUserDataForm.patchValue({
      lstCountry: this.countries,
    });
  }

  /**
   * The `getStatesByCountryId` function retrieves the states related to the selected country
   */
  async getStatesByCountryId() {
    this.globalUserDataForm.patchValue({
      addressDialogState: null,
      addressDialogCity: null,
      addressDialogNeightborhood: null,
      addressDialogStreet: null,
      addressDialogZipCode: null,
      addressDialogTelephoneNumber: null,
      addressDialogWeekDay: null,
      addressDialogWeekNumber: null,
    });
    let country = this.globalUserDataForm.get("addressDialogCountry").value;
    let selCountry = this.countries.filter((e) => {
      return e.descrip == country;
    });
    this.globalUserDataForm.patchValue({ selectedCountry: selCountry[0] });

    const selectedCountry = this.globalUserDataForm.get("selectedCountry").value;
    this.states = await this.apiService.getStatesByCountry(selectedCountry.countryId);
  }

  async getCitiesByCountryState() {
    this.globalUserDataForm.patchValue({
      addressDialogCity: null,
      addressDialogNeightborhood: null,
      addressDialogStreet: null,
      addressDialogZipCode: null,
      addressDialogTelephoneNumber: null,
      addressDialogWeekDay: null,
      addressDialogWeekNumber: null,
    });
    const selectedCountry =
      this.globalUserDataForm.get("selectedCountry").value;
    let dialogState = this.globalUserDataForm.get("addressDialogState").value;
    let state = this.states.filter((e) => {
      return e.descrip == dialogState;
    });

    this.globalUserDataForm.patchValue({
      selectedState: state[0],
    });

    this.cities = await this.apiService.getCitiesFromState({
      country: selectedCountry.countryId,
      state: this.globalUserDataForm.get("selectedState").value.id.stateId,
    });
  }

  async getInitialInfo() {
    this.blocked = true;
    await this.getCountries();
    await this.getZoneId();
    await this.getZonalCoords();
    await this.getNatioData();
  }


  async getNatioData() {
    const natioId = this.natioId;
    const language = this.globalUserPreferences.preferences.language || null;
    let selectedState;
    let selectedCountry;

    if (natioId) {
      try {
        let coordination = await this.apiService.crudNatioCoord(
          {
            language: language,
            method: "GETBYID",
            national: {
              coord: {
                natId: natioId
              }
            }
          }
        );
        const natCoord = coordination.national.coord as NatioCoordModel;
        const mainAddress = coordination.national.storeAddress;
        const storeAddress = coordination.national.warehouseAddress || null;
        const storeId = coordination.national.store.storeId || null;

        // MAIN ADDRESS
        if (mainAddress != null) {
          if (mainAddress.null == false) {
            selectedCountry = this.countries.find((e) => {
              return e.countryId == mainAddress.country;
            });
            // console.log(selectedCountry);
            if (storeId !== null) {
              this.states = await this.apiService.getStatesFromStore({
                storeId: storeId,
              });
            } else {
              this.states = null;
            }

            if (this.states !== null) {
              selectedState = this.states.find((e) => {
                return e.id.stateId == mainAddress.state;
              });

              // Actualiza los valores del address
              this.globalUserDataForm.patchValue({
                coordMainAddress: `${selectedCountry.descrip}, ${selectedState.descrip}, ${mainAddress.street}`,
                mainCountry: selectedCountry.descrip,
                mainState: selectedState.descrip,
                mainCity: mainAddress.city,
                mainNeight: mainAddress.neight,
                mainStreet: mainAddress.street,
                mainZipCode: mainAddress.zipCode,
                selectedCountry: selectedCountry,
                mainAddressId: mainAddress.addrId,
              });
            }
          } else {
            this.globalUserDataForm.patchValue({
              mainAddressId: null,
            });
          }
        }

        // STORE ADDRESS
        if (storeAddress != null) {
          if (storeAddress.null == false) {
            selectedCountry = this.countries.find((e) => {
              return e.countryId == storeAddress.country;
            });
            if (storeId !== null && this.states.length == 0) {
              this.states = await this.apiService.getStatesFromStore({
                storeId: storeId,
              });
            }
            if (this.states !== null && this.states.length > 0) {
              selectedState = this.states.find((e) => {
                return e.id.stateId == storeAddress.state;
              });
              // Actualiza los valores del address
              this.globalUserDataForm.patchValue({
                coordWarehouseAddress: `${selectedCountry.descrip}, ${selectedState.descrip}, ${storeAddress.street}`,
                warehouseCountry: selectedCountry,
                warehouseState: selectedState,
                warehouseCity: storeAddress.city,
                warehouseNeight: storeAddress.neight,
                warehouseStreet: storeAddress.street,
                warehouseZipCode: storeAddress.zipCode,
                selectedCountry: selectedCountry,
                warehouseAddressId: storeAddress.addrId,
              });
            }
          } else {
            this.globalUserDataForm.patchValue({
              warehouseAddressId: null,
            });
          }
        }


        let country = this.countries.find((e) => {
          return e.countryId == natCoord.countryId;
        });

        

        this.globalUserDataForm.patchValue({
          storeId: coordination.national.store.storeId,
          natId: natCoord.natId,
          coordName: natCoord.name,
          shortName: coordination.national.store.shrName,
          begDate: this.tovpilUtils.stringToDate(natCoord.begDate),
          coordEmail: coordination.national.emails[0].value,
          secreEmail: coordination.national.emails[1].value,
          country: country
        });

        this.blocked = false;
      }
      catch (e) {
        console.error("error en getInitialInfo:", e);
        this.blocked = false;
      }
    } else {
      this.blocked = false;
      let supStoreId = this.zonalCoords.find((e) => {
        return e.storeId == this.globalUserDataForm.get('superiorCoord').value;
      });

      this.globalUserDataForm.patchValue({
        superiorCoord: supStoreId
      });
    }
  }

  async getZoneId() {
    const zoneId = this.zoneId;
    let response = await this.apiService.getZoneCoordById({
      zoneId: zoneId
    });

    console.debug(response.storeId);
    this.globalUserDataForm.patchValue({
      superiorCoord: response.storeId
    })

  }

  async getZonalCoords() {
    let zonalCoords = await this.apiService.getZonesCoord();
    this.zonalCoords = zonalCoords.map(e => {
      return {
        storeId: e.storeId,
        name: e.name,
        descrip: e.storeId + " " + e.name
      }
    });
  }

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {
    // console.debug("TovpilCatalogsZonal() onChangeUserPreferences");
    await this.refreshPreferences();
    // RECARGA
    this.initConfigs();
  }


  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language =
      this.globalUserDataForm.get("selectedLanguage").value?.valueId || null;
    let period = this.globalUserDataForm.get("selectedPeriod").value || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  /**
   * The `redirect` function navigates to a specific URL with query parameters based on certain conditions
   * and handles errors accordingly.
   */
  redirect() {
    try {
      // this.refreshPreferences();
      try {
        const url = "sc/catalogs/coordNat";
        this.router.navigate([url], {
          queryParams: {
            zoneId: this.zoneId,
          },
        });
      } catch (navigationError) {
        console.error(
          "An error occurred while navigating to coordination catalog details:",
          navigationError
        );
        //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
      }
    } catch (parseError) {
      console.error(
        "An error occurred while parsing state to JSON:",
        parseError
      );
      //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
    }
  }

  openMainDialog() {
    const country = this.globalUserDataForm.get("mainCountry").value;
    const state = this.globalUserDataForm.get("mainState").value;
    const city = this.globalUserDataForm.get("mainCity").value;
    const neight = this.globalUserDataForm.get("mainNeight").value;
    const street = this.globalUserDataForm.get("mainStreet").value;
    const zipCode = this.globalUserDataForm.get("mainZipCode").value;

    this.modalType = "M";
    this.globalUserDataForm.patchValue({
      addressDialogCountry: country,
      addressDialogState: state,
      addressDialogCity: city,
      addressDialogNeightborhood: neight,
      addressDialogStreet: street,
      addressDialogZipCode: zipCode,
    });

    this.addressDialog = true;
  }

  openWarehouseDialog() {
    const country = this.globalUserDataForm.get("warehouseCountry").value;
    const state = this.globalUserDataForm.get("warehouseState").value;
    const city = this.globalUserDataForm.get("warehouseCity").value;
    const neight = this.globalUserDataForm.get("warehouseNeight").value;
    const street = this.globalUserDataForm.get("warehouseStreet").value;
    const zipCode = this.globalUserDataForm.get("warehouseZipCode").value;
    const addrId = this.globalUserDataForm.get("warehouseAddressId").value;

    this.globalUserDataForm.patchValue({
      addressDialogCountry: country,
      addressDialogState: state,
      addressDialogCity: city,
      addressDialogNeightborhood: neight,
      addressDialogStreet: street,
      addressDialogZipCode: zipCode,
      addressDialogId: addrId,
    });
    this.modalType = "W";
    this.addressDialog = true;
  }

  /**
   * The function searches for countries based on a query and populates a filtered list of country
   * descriptions.
   * @param event - The `event` parameter in the `searchCountry` function likely represents an event
   * object that is passed to the function when it is triggered. This object may contain information
   * about the event that triggered the function, such as user input or interaction details. In this
   * case, it seems that the `event`
   */
  searchCountry(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.countries.length; i++) {
      let country = this.countries[i];
      if (country.descrip.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        console.debug(country);
        filtered.push(country.descrip);
      }
    }
    this.filteredCountries = filtered;
  }

  /**
   * The function `searchStates` filters an array of states based on a query string and populates the
   * `filteredStates` array with matching results.
   * @param event - The `event` parameter is likely an object that contains information about the event
   * triggering the search, such as the query string entered by the user.
   */
  searchStates(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.states.length; i++) {
      let state = this.states[i];
      if (state.descrip.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state.descrip);
      }
    }
    this.filteredStates = filtered;
  }

  /**
   * The function `searchCities` filters a list of cities based on a query string and updates the
   * filtered list.
   * @param event - The `event` parameter is an object that contains information about the event that
   * triggered the searchCities function. This could include details such as the query string entered
   * by the user for searching cities.
   */
  searchCities(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.cities.length; i++) {
      let city = this.cities[i];
      if (city.value.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(city.value);
      }
    }
    this.filteredCities = filtered;
  }

  /**
   * The function `selectCounty` filters a list of cities based on a specific value and updates a form
   * with the selected city.
   */
  selectCounty() {
    this.globalUserDataForm.patchValue({
      addressDialogNeightborhood: null,
      addressDialogStreet: null,
      addressDialogZipCode: null,
      addressDialogTelephoneNumber: null,
      addressDialogWeekDay: null,
      addressDialogWeekNumber: null,
    });
    const selectedCity = this.cities.filter((e) => {
      e.value == this.globalUserDataForm.get("addressDialogCity").value;
    });

    this.globalUserDataForm.patchValue({
      selectedCity: selectedCity[0],
    });
  }

  /**
   * The function `setAddress` updates the address values in a form based on the modal type and clears
   * the modal values.
   */
  async setAddress() {
    const dialogCountry = this.globalUserDataForm.get("addressDialogCountry").value;
    const dialogState = this.globalUserDataForm.get("addressDialogState").value;
    const dialogStreet = this.globalUserDataForm.get("addressDialogStreet").value;
    const dialogCity = this.globalUserDataForm.get("addressDialogCity").value;
    const dialogNeight = this.globalUserDataForm.get("addressDialogNeightborhood").value;
    const dialogZipCode = this.globalUserDataForm.get("addressDialogZipCode").value;
    const dialogAddressId = this.globalUserDataForm.get("addressDialogId").value;

    const address = `${dialogCountry}, ${dialogState}, ${dialogStreet}`;

    let addresbookCountry = this.countries.find((e) => {
      return e.descrip == dialogCountry;
    });
    let addresbookState = this.states.find((e) => {
      return e.descrip == dialogState;
    });

    let addressObj: AddressBook = {
      addrId: dialogAddressId,
      city: dialogCity,
      country: addresbookCountry.countryId,
      neight: dialogNeight,
      state: addresbookState.id.stateId,
      street: dialogStreet,
      zipCode: dialogZipCode,
    };

    if (this.modalType == "M") {
      let addressResponse = await this.addresCU(addressObj);
      this.globalUserDataForm.patchValue({
        coordMainAddress: address,
        mainCountry: dialogCountry,
        mainState: dialogState,
        mainCity: dialogCity,
        mainNeight: dialogNeight,
        mainStreet: dialogStreet,
        mainZipCode: dialogZipCode,
        mainAddress: addressResponse,
        mainAddressId: addressResponse.addrId,
      });
    } else if (this.modalType == "W") {
      let addressResponse = await this.addresCU(addressObj);
      this.globalUserDataForm.patchValue({
        coordWarehouseAddress: address,
        warehouseCountry: dialogCountry,
        warehouseState: dialogState,
        warehouseCity: dialogCity,
        warehouseNeight: dialogNeight,
        warehouseStreet: dialogStreet,
        warehouseZipCode: dialogZipCode,
        warehouseAddress: addressResponse,
        warehouseAddressId: addressResponse.addrId,
      });
    }
    this.clearModalValues();
    this.modalType = null;
    this.addressDialog = false;
  }

  /**
   * The function `clearModalValues` resets the values of various fields in a form.
   */
  clearModalValues() {
    this.globalUserDataForm.patchValue({
      addressDialogCountry: null,
      addressDialogState: null,
      addressDialogCity: null,
      addressDialogNeightborhood: null,
      addressDialogStreet: null,
      addressDialogZipCode: null,
      addressDialogTelephoneNumber: null,
      addressDialogWeekDay: null,
      addressDialogWeekNumber: null,
    });
  }

  /**
   * The function `updateMinDate` sets the minimum end date based on the parsed start date from a form
   * input.
   */
  updateMinDate() {
    const parsedStartDate = this.parseDate(
      this.globalUserDataForm.get("coordDateStart").value
    );
    if (parsedStartDate) {
      this.minEndDate = parsedStartDate;
    }
  }

  // Custom validation to check if the end date is valid
  isInvalidEndDate(): boolean {
    const parsedEndDate = this.parseDate(
      this.globalUserDataForm.get("coordDateEnd").value
    );
    if (!parsedEndDate || !this.minEndDate) {
      return false;
    }
    return parsedEndDate < this.minEndDate;
  }

  // Utility function to parse a date in the format dd/mm/yyyy
  parseDate(dateString: string): Date | null {
    const parts = dateString.split("/");
    if (parts.length !== 3) {
      return null;
    }
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-based in JS Date
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  async addresCU(addressObj: AddressBook) {
    let res: AddressBook;
    if (addressObj.addrId === null) {
      res = await this.apiService.createAddressbook(addressObj);
    } else {
      res = await this.apiService.updateAddressBook(addressObj);
    }
    return res;
  }


  saveRecord() {
    this.confirmationService.confirm({
      message: '¿ ' + this.translations.lbl_are_you_sure + ' ' + this.translations.lbl_confirm + ' ?',
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-info",
      rejectButtonStyleClass: "p-button-danger",
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      accept: async () => {
        this.blocked = true;
        const natId = this.natioId ?? null;
        const mainAddressId = this.globalUserDataForm.get("mainAddressId").value || null;
        const warehouseAddressId = this.globalUserDataForm.get("warehouseAddressId").value || null;
        const inventory = this.globalUserDataForm.get("coordInventory").value;
        const begDate = this.globalUserDataForm.get("begDate").value;
        const countryId = this.globalUserDataForm.get("country").value ? this.globalUserDataForm.get("country").value.countryId : null;
        const method = natId !== null ? "UPDATE" : "CREATE";
        const storeId = this.globalUserDataForm.get("storeId").value;
        const zoneId = this.zoneId;

        const request = {
          language: "es",
          method: method,
          zoneId: zoneId,
          national: {
            coord: {
              natId: natId,
              begDate: this.tovpilUtils.dateToTovpilDate(begDate),
              invCtl_YN: inventory,
              address: mainAddressId,
              countryId: countryId,
            },
            store: {
              storeId: storeId,
              descri: this.globalUserDataForm.get("coordName").value,
              shrName: this.globalUserDataForm.get("shortName").value,
              addrId: warehouseAddressId,
            },
            emails: [
              {
                id: null,
                key: null,
                storeId: null,
                value: this.globalUserDataForm.get("coordEmail").value,
              },
              {
                id: null,
                key: null,
                storeId: null,
                value: this.globalUserDataForm.get("secreEmail").value,
              }
            ],
          },
        };
        try {
          await this.apiService.crudNatioCoord(request);
          this.redirect();
        } catch (error) {
          console.error("No se pudo guardar la nueva zona: ", error);
          this.blocked = false;
        }
      }
    });

  }
}

